module.exports = __webpack_public_path__ + "static/investor-illustration-a69f7ba35525c3f90f500ed0650039dc.png";